import { FramePlugin } from '../../DolEditor/elements/Frame/plugin';
import { UploadAudioPlugin } from '../../DolEditor/elements/UploadAudio/plugin';
import { UploadFilePlugin } from '../../DolEditor/elements/UploadFile/plugin';
import { UploadImagePlugin } from '../../DolEditor/elements/UploadImage/plugin';
import { UploadVideoPlugin } from '../../DolEditor/elements/UploadVideo/plugin';
import { VocabCardPlugin } from '../../DolEditor/elements/vocab-card/plugin';
import { VocabListPlugin } from '../../DolEditor/elements/vocab-list/plugin';
import { ImageSlideShowPlugin } from '../plugins/SpecialObject/ImageSlide/SlideShow/ImageSlideShowPlugin';
import { ImageSlideTextPlugin } from '../plugins/SpecialObject/ImageSlide/SlideText/ImageSlideTextPlugin';
import { VocabListNewsPlugin } from '../plugins/VocabListNews/VocabListNewsPlugin';

export const getAllMediaObjectPlugins = ({ isReadOnly }) => [
  // media object
  UploadImagePlugin({ isPreview: isReadOnly, withoutStore: true }),
  UploadVideoPlugin({ isPreview: isReadOnly }),
  UploadAudioPlugin({ isPreview: isReadOnly }),
  UploadFilePlugin({ isPreview: isReadOnly }),
  ImageSlideShowPlugin({ isReadOnly }), // carousel image
  ImageSlideTextPlugin({ isReadOnly }), // same with slide show but come with text input
  VocabListPlugin({ isPreview: isReadOnly }), // use google sheet to import a vocab list
  VocabCardPlugin({ isPreview: isReadOnly }), // manual input a vocab
  VocabListNewsPlugin({ isPreview: isReadOnly }), // same with vocab list but render differently
  FramePlugin({ isPreview: isReadOnly }),
];
